import React, { useMemo, useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { compose } from "redux";
import { withStyles, withBreakpoint, withMobile } from "components/common";
import Table from "components/common/Table";
import TableFilter from "components/common/TableFilter";
import CustomHeader from "components/common/Table/CustomHeader";

const moment = require("moment");

const itemsPerPage = 20;

const computeColumns = () =>[
            {
                Header: "User",
                accessor: data => (data.User || {}).email || "no email"
            },
            {
                Header: "Transaction ID",
                accessor: data => data.transaction.id || "no trans id"
            },
            {
                Header: "Disputed Amount",
                accessor: data => data.disputed_amount || data.transaction.amount
            },
            {
                Header: "Submit Date",
                accessor: data => moment.unix(parseInt(data.created_at) / 1000).format("M/D/YYYY (h:mma)")
            },
            {
                Header: "Status",
                accessor: data => data.status || "not_reviewed"
            },
            {
                Header: "Galileo Status",
                accessor: data => data.galileo_status || ""
            }
        ];

const DisputesTable = ({
    disputes = [],
    loading,
    breakpointContext: { isBelow }
}) => {
    const columns = useMemo(() => computeColumns(), []);
    const history = useHistory();
    
    const [filteredDisputes, setFilteredDisputes] = useState(disputes);
    const [page, setPage] = useState(0);

    useEffect(() => {
        setPage(0);
    }, [filteredDisputes]);
    
    const getFilterByStatus = (status) => {
        let filtered = [];

        switch (status){
            case "all":
                filtered = disputes;
                break;
            case "not_reviewed":
                filtered = disputes.filter(d => !d.status);
                break;
            default:
                filtered = disputes.filter(d => d.status === status);
                break;
        };
        setFilteredDisputes(filtered);
    };

    const searchByEmail = (str) => {
        let filtered = disputes.filter(d => d.User.email.indexOf(str) === 0);
        setFilteredDisputes(filtered);
    };

    const mapping = {
        all: {
            name: `All`,
            fn: () => getFilterByStatus("all")
        },
        not_reviewed: {
            name: `Not Reviewed`,
            fn: () => getFilterByStatus("not_reviewed")
        },
        forwarded: {
            name: `Forwarded`,
            fn: () => getFilterByStatus("forwarded")
        },
        honored: {
            name: `Honored`,
            fn: () => getFilterByStatus("honored")
        },
        canceled: {
            name: `Canceled`,
            fn: () => getFilterByStatus("canceled")
        },
        denied: {
            name: `Denied`,
            fn: () => getFilterByStatus("denied")
        }
    };

    const getRowStyle = row => {
        const color_code = {
            honored: "#E5FFE5",
            canceled: "#FFE4E5",
            denied: "#FFE4E5",
            forwarded: "#FFE9AB"
        };
        
        return {
            backgroundColor: row.original.status ? color_code[row.original.status] : ""
        };
    };
    return (
        <div className="mt-5">
            <h1 className="text-2xl font-title mb-2 font-light">
                Admin: All Disputes
      </h1>
            <div className="my-6">
                {loading ? (
                    <div>Loading...</div>
                ) : disputes.length ? (
                    <div className="flex flex-col">
                        <TableFilter
                        mapping={mapping}
                        containerClassName="flex-initial text-gray-primary font-light"
                        initialActive={"all"}
                        />
                        <div className="my-6">
                            <Table
                                id="disputes"

                                data={filteredDisputes.slice(page * itemsPerPage, (page + 1) * itemsPerPage)}
                                columns={columns}
                                getRowStyle={getRowStyle}
                                onRowClick={(e, row) => {
                                    history.push(`/admin/god/dispute/${row.original.id}`)
                                }}
                                itemsPerPage={itemsPerPage}
                                HeaderComponent={
                                    () => (
                                        // <div className="flex">
                                        //     <p>
                                        //         Search:{" "}
                                        //         <input
                                        //             className="p-1"
                                        //             // value={searchQuery}
                                        //             onChange={(e) => setSearchQuery(e.target.value)}
                                        //             onKeyDown={(e) => (e.key == "Enter" ? doSearch(searchQuery) : 0)}
                                        //         />
                                        //     </p>
                                        // </div>
                                        <div className="flex">
                                            <CustomHeader
                                                nextPage={() => setPage(page + 1)}
                                                canNextPage={
                                                    page < Math.ceil(filteredDisputes.length / itemsPerPage) - 1
                                                }
                                                previousPage={() => setPage(page - 1)}
                                                canPreviousPage={page > 0}
                                                gotoPage={(page) => setPage(page)}
                                                pageCount={Math.ceil(filteredDisputes.length / itemsPerPage)}
                                                pageIndex={page}
                                                doSearch={(searchQuery) => searchByEmail(searchQuery)}
                                                showGotoPage={false}
                                                showSuperJump={false}

                                            />
                                        </div>
                                    )
                                }
                            />
                        </div>
                    </div>
                ) : (
                            <div>Currently there are no disputes.</div>
                        )}
            </div>
        </div>
    );
};

export default compose(
    withMobile,
    withStyles,
    withBreakpoint
)(DisputesTable);
